import { render, staticRenderFns } from "./ProSettlement.vue?vue&type=template&id=82088142&scoped=true&"
import script from "./ProSettlement.vue?vue&type=script&lang=js&"
export * from "./ProSettlement.vue?vue&type=script&lang=js&"
import style0 from "./ProSettlement.vue?vue&type=style&index=0&id=82088142&lang=less&scoped=true&"
import style1 from "./ProSettlement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82088142",
  null
  
)

export default component.exports